// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__e3MRP","infoItem":"styles_infoItem__3XsYh"};